import type { PaymentMethodDtoWithIsPreferred } from 'korint-sdk';
import { useTranslation } from 'react-i18next';
import { Badge } from '@folio/components/ui/badge';

export const PaymentMethodStatusBadge = ({
  status,
}: {
  status: PaymentMethodDtoWithIsPreferred['status'];
}) => {
  const { t } = useTranslation();

  if (status === 'WAITING_MANDATE_SIGNATURE') {
    return (
      <Badge variant="light" tone="warning" size="sm">
        {t('customerPaymentMethods.badges.waitingMandate')}
      </Badge>
    );
  }
  if (status === 'INVALID_MANDATE') {
    return (
      <Badge variant="light" tone="destructive" size="sm">
        {t('customerPaymentMethods.badges.invalidMandate')}
      </Badge>
    );
  }
  if (status === 'EXPIRED') {
    return (
      <Badge variant="light" tone="destructive" size="sm">
        {t('customerPaymentMethods.badges.expired')}
      </Badge>
    );
  }
  return null;
};
